<script>
	import { getText } from '../../../../share/utils';
</script>

<div class="page-special-surgery marginbox">
	<div class="flex structure">
		<div class="flex element">
			<img loading="lazy" alt="Individuelle Klasse - OP-Saal" src="./../img/16.Individuelle_Klasse/02.surgery/MED_1.webp">
		</div>
		
		<div class="flex col structure-1">
			<div class="flex element">
				<img loading="lazy" alt="Individuelle Klasse - OP-Saal-Konfigurator - Design" src="./../img/16.Individuelle_Klasse/02.surgery/3D-OP-interface-raummaße.webp">
			</div>
			<div class="flex element">
				<img loading="lazy" alt="Individuelle Klasse - OP-Saal-Konfigurator" src="./../img/16.Individuelle_Klasse/02.surgery/MED_2.webp">
			</div>
			<div class="flex col element text">
					<h2>{getText("16.02.01_quote")}</h2>
					<p class="caption">Monika Kühn-Görg</p>
			</div>
		</div>
		
		<div class="flex col structure-2">
			<div class="flex col element text">
				<h2>{getText("16.02.02_h2")}</h2>
				<p class="caption">{getText("16.02.03_caption")}</p>
				<p class="caption blue">Project Lead: <a href="//www.eckpunkt.com" target="_blank">www.eckpunkt.com</a></p>
			</div>
			<div class="flex element">
				<img loading="lazy" alt="Individuelle Klasse - OP-Saal-Konfigurator - 3D-Design" src="./../img/16.Individuelle_Klasse/02.surgery/3D-Console-Configurator.webp">
			</div>
			<div class="flex element">
				<img loading="lazy" alt="Individuelle Klasse - OP-Saal-Konfigurator - mobile-Design" src="./../img/16.Individuelle_Klasse/02.surgery/MED_3.webp">
			</div>
		</div>
	</div>
</div>

<style lang="scss">
	@import "../../../../style/mixins";
	@import "../../../../style/variables";
	
	img {
		width: 100%;
		margin: 0;
		padding: 0;
	}
	
	.page-special-surgery {
		margin-top: $spacing-mobile;
		
		.flex {
			display: flex;
			box-sizing: border-box;
		}
		
		.row {
			flex-flow: row wrap;
		}
		
		.col {
			flex-flow: column wrap;
		}
		
		.element {
			min-width: 100px;
		}
		
		.structure {
			flex-flow: row wrap;

			> .element {
				margin-bottom: $media-gap;
				width: 90%;
			}
		}
		
		.structure-1,
		.structure-2 {
			width: 100%;
			padding: 0;
			position: relative;
			
			> .element {
				width: 100%;
				margin-bottom: $media-gap;
				height: fit-content;
			}
		}
		
		.structure-1 {
			align-items: end;
			
			@include for-tablet-portrait-up {
				width: 50%;
			}
			
			.text {
				padding-right: 10%;
			}
		}
		
		.structure-2 {
			margin-bottom: $media-gap;
			
			@include for-tablet-portrait-up {
				width: 50%;
				padding-left: $media-gap;
			}
		}
		
		.text {
			margin: 0;
		}
	}
</style>
